/** Digits only: país + número (EE. UU.) para https://wa.me/{número} */
export const KAILAC_WHATSAPP_NUMBER = '19784794981';

export const KAILAC_TEL_HREF = 'tel:+19784794981';

/** Texto mostrado en la UI */
export const KAILAC_PHONE_DISPLAY = '(978) 479-4981';

/** Schema.org / datos estructurados */
export const KAILAC_PHONE_SCHEMA = '+1-978-479-4981';
